import type { ApiContext } from "@hobbyshopify/backend-client";
import type { AuthHandler } from "trunk.js";
import { shopEntryId } from "../primitives/workspace";
import type { PendingCartsRepository } from "../repositories/pending-carts-repository";
import type { BackendApi } from "./api";

/** The badge count. Best effort: a failure keeps the last number rather than claiming zero. */
export async function loadPendingCarts(o: {
  client: BackendApi;
  authHandler: AuthHandler<ApiContext>;
  pendingCartsRepository: PendingCartsRepository;
  storeId: string;
  locationId: string | null;
}): Promise<void> {
  const r = await o.authHandler.callApi((ctx) =>
    o.client.customerCart.pendingCount(ctx, shopEntryId(o.storeId, o.locationId)),
  );
  if (r.ok) o.pendingCartsRepository.setCount(r.value);
}

/** Whether the counter has a stream running, which can be a co-host on another device. Null when unknown. */
export async function isStreamLive(o: {
  client: BackendApi;
  authHandler: AuthHandler<ApiContext>;
  storeId: string;
  locationId: string | null;
}): Promise<boolean | null> {
  const r = await o.authHandler.callApi((ctx) => o.client.live.streams(ctx, shopEntryId(o.storeId, o.locationId)));
  if (!r.ok) return null;
  return r.value.some((stream) => stream.status === "LIVE");
}
